import { useId } from 'react'

/** Original Figma illustration, node 767:13051. */
export function NoResultsIllustration() {
  const id = useId()
  return (
    <svg
      aria-hidden
      className='h-auto w-[240px] max-w-full'
      width='489'
      height='387'
      viewBox='0 0 489 387'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath={`url(#${id}-clip0_767_13051)`}>
        <path
          d='M27.9942 282.693C74.8419 198.028 45.3399 194.986 22.1222 168.385C-0.114414 142.907 -3.71152 104.037 3.09881 70.9248C9.89492 37.7983 35.3306 7.44418 68.586 1.27383C118.988 -8.06699 165.438 37.0874 216.664 35.2676C242.74 34.3292 266.612 21.3061 291.436 13.2591C350.212 -5.79221 422.211 7.10295 460.087 55.9254C493.314 98.734 494.324 158.959 481.002 211.492C467.41 265.077 439.415 316.359 395.581 350.04C351.748 383.721 290.924 397.413 239.271 377.722C202.418 363.661 165.352 333.435 128.4 347.225C116.287 351.746 61.2781 377.224 36.5817 348.448C25.961 336.065 18.582 299.725 27.9942 282.707V282.693Z'
          fill={`url(#${id}-paint0_linear_767_13051)`}
        />
        <g filter={`url(#${id}-filter0_dd_767_13051)`}>
          <path
            d='M139.798 112.833L138.206 96.4975C137.481 89.005 144.064 82.2233 152.907 81.356L319.042 65.1482L328.653 43.7226C329.848 41.0639 332.691 39.1872 335.99 38.8602L374.975 35.05C379.724 34.5808 383.889 37.4669 384.288 41.4905L404.903 252.747C404.903 254.78 404.69 261.049 400.155 266.793C393.87 274.755 384.415 275.238 383.008 275.295L157.798 297.275L139.798 112.833Z'
            fill='#A6C0F3'
          />
          <path
            d='M94.1448 117.283L338.791 93.4123C345.174 92.7868 351.771 97.379 353.506 103.649L397.411 262.215C399.145 268.499 395.377 274.087 388.994 274.712L144.348 298.583C137.964 299.209 131.367 294.617 129.632 288.347L85.7279 129.78C83.9933 123.496 87.761 117.909 94.1448 117.283Z'
            fill={`url(#${id}-paint1_linear_767_13051)`}
          />
          <mask
            id={`${id}-mask0_767_13051`}
            style={{ maskType: 'luminance' }}
            maskUnits='userSpaceOnUse'
            x='257'
            y='181'
            width='93'
            height='74'
          >
            <path
              d='M349.109 181.219H257.199V254.069H349.109V181.219Z'
              fill='white'
            />
          </mask>
          <g mask={`url(#${id}-mask0_767_13051)`}>
            <path
              d='M344.909 213.789C339.079 213.789 333.199 211.599 328.589 207.679C323.649 203.489 320.269 197.389 319.329 190.959C319.089 189.319 320.219 187.799 321.859 187.559C323.499 187.319 325.019 188.449 325.259 190.089C325.989 195.099 328.619 199.839 332.469 203.109C336.279 206.349 341.169 208.049 345.919 207.759C347.569 207.659 348.999 208.919 349.089 210.579C349.189 212.229 347.929 213.649 346.269 213.749C345.809 213.779 345.349 213.789 344.889 213.789H344.909Z'
              fill='#A6C0F3'
            />
            <path
              d='M266.059 202.709C263.819 202.709 261.569 202.399 259.369 201.769C257.779 201.309 256.859 199.649 257.319 198.059C257.779 196.469 259.439 195.549 261.029 196.009C265.659 197.339 270.629 196.789 274.649 194.479C278.679 192.169 281.689 188.159 282.889 183.479C283.299 181.879 284.929 180.909 286.539 181.319C288.139 181.729 289.109 183.369 288.699 184.969C287.099 191.209 283.059 196.569 277.639 199.679C274.139 201.679 270.129 202.709 266.069 202.709H266.059Z'
              fill='#A6C0F3'
            />
            <path
              d='M288.449 254.069C288.129 254.069 287.799 254.019 287.479 253.909C285.909 253.369 285.079 251.669 285.609 250.099C287.639 244.189 292.139 239.199 297.959 236.399C303.729 233.629 310.649 233.099 316.929 234.939C318.519 235.409 319.429 237.069 318.969 238.659C318.499 240.249 316.829 241.159 315.249 240.699C310.369 239.269 305.019 239.669 300.559 241.809C296.179 243.909 292.799 247.639 291.289 252.039C290.859 253.289 289.699 254.069 288.449 254.069Z'
              fill='#A6C0F3'
            />
            <path
              d='M282.829 218.299C286.849 217.279 289.239 212.979 288.149 208.699C287.069 204.419 282.929 201.769 278.899 202.789C274.869 203.809 272.489 208.109 273.579 212.389C274.659 216.669 278.799 219.319 282.829 218.299Z'
              fill='#A6C0F3'
            />
            <path
              d='M283.46 209.201C284.504 209.014 285.174 207.879 284.956 206.667C284.739 205.455 283.716 204.624 282.673 204.811C281.629 204.998 280.959 206.133 281.177 207.345C281.394 208.557 282.416 209.388 283.46 209.201Z'
              fill='white'
            />
            <path
              d='M320.859 220.559C324.879 219.539 327.269 215.239 326.179 210.959C325.099 206.679 320.959 204.029 316.929 205.049C312.909 206.069 310.519 210.369 311.609 214.649C312.689 218.929 316.829 221.579 320.859 220.559Z'
              fill='#A6C0F3'
            />
            <path
              d='M321.492 211.47C322.535 211.283 323.205 210.149 322.988 208.936C322.77 207.724 321.748 206.893 320.704 207.081C319.66 207.268 318.991 208.402 319.208 209.615C319.426 210.827 320.448 211.658 321.492 211.47Z'
              fill='white'
            />
          </g>
        </g>
        <path
          opacity='0.35'
          d='M187.131 194.27C226.479 194.27 258.377 162.373 258.377 123.027C258.377 83.6801 226.479 51.7834 187.131 51.7834C147.783 51.7834 115.886 83.6801 115.886 123.027C115.886 162.373 147.783 194.27 187.131 194.27Z'
          fill={`url(#${id}-paint2_linear_767_13051)`}
        />
        <path
          d='M222.789 47.0633C181.344 26.505 130.615 43.6654 110.199 85.1801C93.8481 118.434 101.512 157.134 126.35 181.787L66.7348 270.745C61.7727 278.153 63.749 288.176 71.1565 293.138C78.564 298.1 88.5875 296.123 93.5495 288.716L153.207 199.687C194.141 216.79 241.742 198.976 261.149 158.527C281.025 117.084 263.85 67.4368 222.789 47.0775V47.0633ZM156.236 183.195C122.568 167.044 108.364 126.652 124.516 92.9855C140.767 59.1339 180.861 45.0302 214.714 61.2665C248.396 77.4174 262.585 117.809 246.434 151.476C230.183 185.327 190.088 199.431 156.236 183.195Z'
          fill='#A6C0F3'
        />
        <g filter={`url(#${id}-filter1_dd_767_13051)`}>
          <path
            d='M344.366 176.524C338.041 177.812 331.716 179.1 325.395 180.378C326.92 188.452 322.717 197.32 315.996 201.841C312.415 202.258 309.047 204.299 307 207.284C310.917 204.091 316.685 205.176 321.397 206.923C326.109 208.671 331.09 210.967 335.958 209.665C340.873 208.358 344.257 203.546 345.405 198.563C346.553 193.58 345.876 188.387 344.36 176.51L344.366 176.524Z'
            fill={`url(#${id}-paint3_linear_767_13051)`}
          />
        </g>
        <g filter={`url(#${id}-filter2_dd_767_13051)`}>
          <path
            d='M359.048 196.444L358.619 184.956C363.003 185.564 367.598 184.534 371.338 182.097C374.173 180.251 376.499 177.647 379.5 176.083C383.549 173.971 388.404 173.996 392.768 175.197C397.133 176.398 401.121 178.656 405.055 180.905C402.454 180.509 399.81 180.109 397.194 180.504C394.578 180.898 391.97 182.207 390.621 184.511C389.582 186.298 389.373 188.502 388.164 190.167C387.001 191.769 385.114 192.612 383.329 193.425C374.171 197.596 365.439 202.713 357.293 208.686C357.043 207.184 359.403 205.931 359.054 196.457L359.048 196.444Z'
            fill={`url(#${id}-paint4_linear_767_13051)`}
          />
        </g>
      </g>
      <defs>
        <filter
          id={`${id}-filter0_dd_767_13051`}
          x='59.4595'
          y='30.6923'
          width='371.29'
          height='315.333'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='8.61538' />
          <feGaussianBlur stdDeviation='4.30769' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.0901961 0 0 0 0 0.219608 0 0 0 0 0.482353 0 0 0 0.03 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_767_13051'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='21.5385' />
          <feGaussianBlur stdDeviation='12.9231' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.0902477 0 0 0 0 0.2203 0 0 0 0 0.480404 0 0 0 0.08 0'
          />
          <feBlend
            mode='normal'
            in2='effect1_dropShadow_767_13051'
            result='effect2_dropShadow_767_13051'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect2_dropShadow_767_13051'
            result='shape'
          />
        </filter>
        <filter
          id={`${id}-filter1_dd_767_13051`}
          x='281.154'
          y='172.202'
          width='90.6743'
          height='85.2302'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='8.61538' />
          <feGaussianBlur stdDeviation='4.30769' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.0901961 0 0 0 0 0.219608 0 0 0 0 0.482353 0 0 0 0.03 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_767_13051'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='21.5385' />
          <feGaussianBlur stdDeviation='12.9231' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.0902477 0 0 0 0 0.2203 0 0 0 0 0.480404 0 0 0 0.08 0'
          />
          <feBlend
            mode='normal'
            in2='effect1_dropShadow_767_13051'
            result='effect2_dropShadow_767_13051'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect2_dropShadow_767_13051'
            result='shape'
          />
        </filter>
        <filter
          id={`${id}-filter2_dd_767_13051`}
          x='331.428'
          y='170.069'
          width='99.4729'
          height='86.002'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='8.61538' />
          <feGaussianBlur stdDeviation='4.30769' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.0901961 0 0 0 0 0.219608 0 0 0 0 0.482353 0 0 0 0.03 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_767_13051'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='21.5385' />
          <feGaussianBlur stdDeviation='12.9231' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.0902477 0 0 0 0 0.2203 0 0 0 0 0.480404 0 0 0 0.08 0'
          />
          <feBlend
            mode='normal'
            in2='effect1_dropShadow_767_13051'
            result='effect2_dropShadow_767_13051'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect2_dropShadow_767_13051'
            result='shape'
          />
        </filter>
        <linearGradient
          id={`${id}-paint0_linear_767_13051`}
          x1='297.507'
          y1='457.467'
          x2='190.481'
          y2='-154.493'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='0.05' stopColor='#F6F8FF' />
          <stop offset='0.13' stopColor='#DFE5FF' />
          <stop offset='0.47' stopColor='#E9EDFF' />
          <stop offset='0.84' stopColor='#EFF2FF' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id={`${id}-paint1_linear_767_13051`}
          x1='226.855'
          y1='157.893'
          x2='303.53'
          y2='357.357'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='0.78' stopColor='#ECEEFF' />
        </linearGradient>
        <linearGradient
          id={`${id}-paint2_linear_767_13051`}
          x1='245.001'
          y1='81.502'
          x2='129.543'
          y2='165.067'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='white' />
          <stop offset='0.78' stopColor='#ECEEFF' />
        </linearGradient>
        <linearGradient
          id={`${id}-paint3_linear_767_13051`}
          x1='320.458'
          y1='215.311'
          x2='336.36'
          y2='182.587'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#E9EDFF' />
          <stop offset='0.19' stopColor='#E0E6FF' />
          <stop offset='0.22' stopColor='#DFE5FF' />
          <stop offset='0.6' stopColor='#EFF2FF' />
          <stop offset='0.86' stopColor='#F0F3FF' />
          <stop offset='0.95' stopColor='#F7F9FF' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <linearGradient
          id={`${id}-paint4_linear_767_13051`}
          x1='366.486'
          y1='214.7'
          x2='383.179'
          y2='180.368'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#E9EDFF' />
          <stop offset='0.19' stopColor='#E0E6FF' />
          <stop offset='0.22' stopColor='#DFE5FF' />
          <stop offset='0.6' stopColor='#EFF2FF' />
          <stop offset='0.86' stopColor='#F0F3FF' />
          <stop offset='0.95' stopColor='#F7F9FF' />
          <stop offset='1' stopColor='white' />
        </linearGradient>
        <clipPath id={`${id}-clip0_767_13051`}>
          <rect width='489' height='387' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
